/**
 * Function which returns a flag indicating whether or not the current device is a mobile device
 * @returns boolean flag indicating whether or not the current user agent is a mobile device
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
